import { atom } from 'nanostores'

export const $isSubscribedViewOpen = atom<boolean>(false)

export const openSubscribedView = () => {
  $isSubscribedViewOpen.set(true)
}

export const closeSubscribedView = () => {
  $isSubscribedViewOpen.set(false)
}
